module.exports = __webpack_public_path__ + "static/media/img4.2147265e.jpeg";